module.exports = __webpack_public_path__ + "2acb60f2/img/comment-question-icon.7dd26e04.svg";